const contentKeys = {
	NotificationDrawer: 'NotificationDrawer',
	MobileNavMenu: 'MobileNavMenu',
};

export default contentKeys;
